/*https://github.com/pupunzi/jquery.mb.YTPlayer*/

$(document).ready(() =>
{
    let preloadVideoCount = 0;
    /** @type {VideoPlayer[]} */
    const videoPlayers = [];

    const applyActiveState = () =>
    {
        if(preloadVideoCount > 0){
            return;
        }
        $("body.has-preloader").addClass('content-loaded');
        for(let i = 0; i < videoPlayers.length; i ++){
            const videoPlayer = videoPlayers[i];
            if(videoPlayer.playAfterPreload){
                videoPlayer.handleAutoplay();
            }
        }
    }

    class VideoPlayer
    {
        /**
         *
         * @param $videoPlayer {jQuery}
         * @param source {string}
         */
        constructor($videoPlayer, source) {

            this.$videoPlayer = $videoPlayer;
            this.$video = $videoPlayer.find("video");
            this.$controls = $videoPlayer.find(".video-controls");
            this.$spinner = $videoPlayer.find(".spinner");
            this.source = source;
            this.doLoop = !!$videoPlayer.data("do-loop");
            this.doPreload = !!$videoPlayer.data("do-preload");
            this.mute = !!$videoPlayer.data("mute");
            const autoplay = !!$videoPlayer.data("autoplay");
            const isJsControlUnavailable = this.isJsControlUnavailable();
            this.autoplay = autoplay && (!this.doPreload || isJsControlUnavailable);
            this.playAfterPreload = autoplay && (this.doPreload && !isJsControlUnavailable);
            this.useCustomControls = !!$videoPlayer.data("use-custom-controls");
            this.showCaptions = !!$videoPlayer.data("show-captions");
            this.hideControls = !!$videoPlayer.data("hide-native-controls") || this.useCustomControls;
            this.url = $videoPlayer.data("url") ?? "";
            this.mimeType = $videoPlayer.data("mime-type") ?? "";
            this.activeTimeout = null;

            if(source !== "local"){
                this.$video.remove();
            }
            if(!this.useCustomControls){
                this.$controls.remove();
            }

            if(this.isValid()){
                this.onValidVideoFound();
                this.initVideo();
            }

            this.$controls.find(".active-area").on("mousemove mousedown mouseenter mouseup click touchmove touchstart touchend", (event) =>
            {
                this.removeActiveTimeout();
                this.$videoPlayer.addClass("active");
                this.activeTimeout = setTimeout(
                    () => {
                        this.$videoPlayer.removeClass("active");
                        this.removeActiveTimeout();
                    },
                    1000
                );
            });
            this.$controls.find(".play-pause").on("touchend mouseup" , (e) =>
            {
                if(this.$videoPlayer.hasClass('playing'))
                {
                    this.pauseVideo();
                } else {
                    this.playVideo();
                }
            })
        }

        removeActiveTimeout()
        {
            if(this.activeTimeout === null){
                return;
            }
            clearTimeout(this.activeTimeout);
            this.activeTimeout = null;
        }


        isValid()
        {
            return !!this.url && !!this.source;
        }

        isJsControlUnavailable()
        {
            return false;
        }


        onValidVideoFound (){
            if(this.doPreload){
                preloadVideoCount ++;
            }
        }

        onReady () {
            this.$videoPlayer.addClass('ready');
            this.$videoPlayer.closest(".video-container").addClass('use-inner-height');
            this.onVideoPreloadEnd();
        }

        onError () {
            this.onVideoPreloadEnd();
        }

        onVideoPreloadEnd () {
            if(this.doPreload){
                preloadVideoCount --;
                applyActiveState();
            }
        }

        initVideo()
        {

        }

        pauseVideo()
        {
            this.$videoPlayer.removeClass('playing');
        }


        handleAutoplay()
        {
            this.playVideo();
        }

        playVideo()
        {
            this.$videoPlayer.addClass('playing');
        }

        updateProgress (prop){
            this.$controls.find(".timeline-progress").css({"width": (prop * 100)+"%"});
        }

        onStart()
        {
            this.$videoPlayer.addClass('playing');
        }

        onStop()
        {
            this.$videoPlayer.removeClass('playing');
        }
    }

    class LocalVideoPlayer extends VideoPlayer
    {
        /**
         *
         * @param $videoPlayer {jQuery}
         */
        constructor($videoPlayer) {
            super($videoPlayer, "local");

            this.videoIntervalID = 0;
        }


        isValid() {
            return super.isValid() && !!this.$video.find("source").length && !!this.mimeType;
        }

        disabledUpdates(){
            clearInterval(this.videoIntervalID)
        }

        enableUpdates(){
            this.disabledUpdates();
            this.videoIntervalID = setInterval(() => {

                const video = this.$video[0];
                let prop = 0;
                if(video.duration && video.currentTime){
                    prop = video.currentTime / video.duration;
                }
                this.updateProgress(prop);
            }, 10);
        }

        handleAutoplay()
        {
            getGlobalClickManager().requireFirstClick(() => {
                this.playVideo();
            })
        }

        initVideo()
        {
            const $video_source = this.$video.find("source");
            $video_source.attr("src", this.url);
            $video_source.attr("type", this.mimeType);
            if(!this.hideControls){
                this.$video.attr("controls", 1);
            }
            if(this.doLoop){
                this.$video.attr("loop", 1);
            }
            const video = this.$video[0];

            this.disabledUpdates();

            video.addEventListener('error', (event) =>  {
                this.onError();
            }, true);
            video.addEventListener('loadeddata', (event) =>  {
                this.onReady();
            }, true);

            video.addEventListener("ended", (event) => {
                this.onVideoEnd();
            });

            this.updateProgress(0);
            video.load();
            if(this.autoplay){
                this.handleAutoplay();
            }
        }

        onVideoEnd () {
            this.disabledUpdates();
        }

        pauseVideo()
        {
            super.pauseVideo();
            this.$video[0].pause();
            this.disabledUpdates();
        }

        playVideo()
        {
            super.playVideo();
            this.$video[0].play();
            this.enableUpdates();
        }
    }

    class YouTubeVideoPlayer extends VideoPlayer
    {
        /**
         *
         * @param $videoPlayer {jQuery}
         */
        constructor($videoPlayer) {
            super($videoPlayer, "youtube");

        }

        initVideo()
        {

            this.$videoPlayer.YTPlayer(
                {
                    // URL of the YouTube video
                    videoURL: this.url,
                    useOnMobile: true,
                    containment:'self',
                    autoPlay:this.autoplay,
                    playOnlyIfVisible:true,
                    optimizeDisplay: false,
                    cc_load_policy: this.showCaptions,
                    loop:this.doLoop,
                    mute:this.mute,
                    startAt:0,
                    opacity:1,
                    showYTLogo:false,
                    useNoCookie:true,
                    onReady: (event) => {
                        this.onReady();
                    },
                    onError: (event) => {
                        this.onError();
                    }
                });



            this.$videoPlayer.on("YTPTime", (event) =>
            {
                const currentTime = event.target?.currentTime ?? 0
                const totalTime = event.target?.totalTime ?? 0
                const prop = currentTime && totalTime ? (currentTime / totalTime) : 0;
                this.updateProgress(prop);
            });

            this.$videoPlayer.on("YTPStart", (event) =>
            {
                this.onStart();
            });

            this.$videoPlayer.on("YTPEnd", (event) =>
            {
                this.onStop();
            });

            this.$videoPlayer.on("YTPPlay", (event) =>
            {
                this.onStart();
            });

            this.$videoPlayer.on("YTPPause", (event) =>
            {
                this.onStop();
            });
        }

        isJsControlUnavailable()
        {
            return true;
        }
    }

    class VimeoVideoPlayer extends VideoPlayer
    {
        /**
         *
         * @param $videoPlayer {jQuery}
         */
        constructor($videoPlayer) {
            super($videoPlayer, "vimeo");

        }

        initVideo()
        {
            this.$videoPlayer.vimeo_player(
                {
                    // URL of the Vimeo video
                    videoURL: this.url,
                    containment:'self',
                    autoPlay:this.autoplay,
                    stopMovieOnBlur:true,
                    optimizeDisplay:false,
                    loop:this.doLoop,
                    mute:this.mute,
                    startAt:0,
                    opacity:1,
                    showControls:!this.hideControls,
                    useNoCookie:true,
                    show_vimeo_logo:false,
                });

            this.$videoPlayer.on("VPReady", (event) =>
            {
                this.onReady();
            });

            this.$videoPlayer.on("VPError", (event) =>
            {
                this.onError();
            });

            this.$videoPlayer.on("VPProgress", (event) =>
            {
                const prop = event.target?.percent ?? 0
                this.updateProgress(prop);
            });

            this.$videoPlayer.on("VPStart", (event) =>
            {
                this.onStart();
            });

            this.$videoPlayer.on("VPEnd", (event) =>
            {
                this.onStop();
            });

            this.$videoPlayer.on("VPPlay", (event) =>
            {
                this.onStart();
            });

            this.$videoPlayer.on("VPPause", (event) =>
            {
                this.onStop();
            });
        }

        pauseVideo()
        {
            super.pauseVideo();
            this.$videoPlayer.v_pause();
        }

        playVideo()
        {
            super.playVideo();
            this.$videoPlayer.v_play();
        }
    }

    $(".video-player").each((index, element) =>
    {
        const $element = $(element);
        const largeOnly = $element.data("large-only");
        const source = $element.data("source");

        if(!largeOnly || window.matchMedia("(min-width: 767px)").matches){
            /** @type {VideoPlayer|null} */
            let videoPlayer = null;
            switch((source ?? "").toLowerCase()){
                case "local":
                    videoPlayer = new LocalVideoPlayer($element);
                    break;
                case "youtube":
                    videoPlayer = new YouTubeVideoPlayer($element);
                    break;
                case "vimeo":
                    videoPlayer = new VimeoVideoPlayer($element);
                    break;
                default:
                    break;
            }
            if(videoPlayer && videoPlayer.isValid()){
                videoPlayers.push(videoPlayer);
            }

        } else {
            $element.addClass("d-none")
        }
    });

    applyActiveState();
});